import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Fade, Backdrop, IconButton, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

interface ViewModalProps {
  image?: string;
  images?: string[];
  alternativeText?: string;
  imageTitle?: string;
}

// export default function BasicModal() {
const ViewModal = ({ image, images, alternativeText, imageTitle }: ViewModalProps) => {
  const [open, setOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
  
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setCurrentImageIndex(0);
  };

  // Déterminer la liste des images à afficher
  const imageList = images || (image ? [image] : []);
  const isGallery = imageList.length > 1;
  const currentImage = imageList[currentImageIndex];

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? imageList.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev === imageList.length - 1 ? 0 : prev + 1));
  };

  return (
    <div>
        <div className='' style={{ width: '100%' }}>
            <button
                className='view-btn'
                type="button"
                onClick={handleOpen}
                style={{ marginLeft: 'auto', display: 'block' }}
            >
                <i className="fa fa-eye" style={{width: 25, opacity: 0.6}}></i>
            </button>
        </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
        <Box sx={{ width: '600px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', border: '0.5px solid rgba(0,0,0,0.12)', borderRadius: 4, boxShadow: 24, p: 4 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
            {imageTitle || 'Aperçu'}
          </Typography>
          <div className='w-100 h-100 d-flex justify-content-center align-items-center' style={{ flexDirection: 'column', gap: '16px' }}>
            <img src={currentImage} alt={alternativeText || "Modal Content"} style={{ width: 'auto', height: 400, overflow: 'hidden' }} />
            
            {isGallery && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', width: '100%' }}>
                <IconButton onClick={handlePrevious} size="small" title="Image précédente">
                  <NavigateBeforeIcon />
                </IconButton>
                <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)', minWidth: '60px', textAlign: 'center' }}>
                  {currentImageIndex + 1} / {imageList.length}
                </span>
                <IconButton onClick={handleNext} size="small" title="Image suivante">
                  <NavigateNextIcon />
                </IconButton>
              </div>
            )}
          </div>
        </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default ViewModal;